import React, { useState, useEffect, useRef } from "react";
import styles from "./Home.module.css";
import { Button } from "react-bootstrap";
import FirstSection from "./FirstSection/FirstSection";
import Lottie from "react-lottie";
import tracking from "./10,000+ Transactions.json";
import Success from "./laptopScreen.json";
import Partner from "./Partner/Partner";
import GlobeSection from "./GlobeSection/GlobeSection";
import Security from "./SecurityCompilance.json";
import zinc from "../../public/assets/zincpart.svg";
import peaceful from "../../public/assets/peacefulpart.svg";
import pw from "../../public/assets/pwpart.svg";
import iifl from "../../public/assets/iiflpart.svg";
import icici from "../../public/assets/ICICI.svg";
import idbi from "../../public/assets/IDBI.svg";
import kotak from "../../public/assets/kotak.svg";
import yes from "../../public/assets/yes bank.svg";
import idfc from "../../public/assets/IDFC Bank.svg";
import indian from "../../public/assets/IndianBank.svg";
import laptopScreen from "../../public/assets/laptopScreen.png";
import SecondSection from "./LottieSections/SecondSection";
import ThirdSection from "./LottieSections/ThirdSection";
import FourthSection from "./LottieSections/FourthSection";
import LetGetStarted from "./LetGetStarted/index";
import { lottieOptions } from "../../utils";
import { useNavigate } from "react-router";
import Footer from "./LandingFooter/Footer";
import { useMyContext } from "../../myContext";

const partnerData = [
  { src: zinc, alt: "zinc", text: "Zinc Corporation" },
  { src: peaceful, alt: "peaceful", text: "Peaceful Ventures" },
  { src: pw, alt: "pw", text: "PwC" },
  { src: iifl, alt: "iifl", text: "IIFL Finance" },
  { src: peaceful, alt: "peaceful", text: "Peaceful Ventures" },
  { src: pw, alt: "pw", text: "PwC" },
];

const bankPartners = [
  { src: icici, alt: "icici", text: "icici" },
  { src: idbi, alt: "idbi", text: "idbi" },
  { src: kotak, alt: "kotak", text: "kotak" },
  { src: yes, alt: "yes", text: "yes" },
  { src: idfc, alt: "idfc", text: "idfc" },
  { src: indian, alt: "indian", text: "indian" },
];

function Home() {
  const [isScrolledPastFirstSec, setIsScrolledPastFirstSec] = useState(false);
  const [currentSection, setCurrentSection] = useState(1);
  const { offlineTransactionFlow, loadingLogo, themeColor, siteLogo } =
    useMyContext();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const firstSecHeight = document.querySelector(
        `.${styles.firstSec}`
      ).offsetHeight;
      setIsScrolledPastFirstSec(window.scrollY >= firstSecHeight);

      const sections = document.querySelectorAll(`.${styles.content}`);
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight / 2 &&
          rect.bottom >= window.innerHeight / 2
        ) {
          const sectionId = section.getAttribute("data-section");
          setCurrentSection(Number(sectionId));
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={styles.mainPage}>
      <header className={styles.header}>
        {loadingLogo ? (
          <img src={siteLogo} alt="logo" className={styles.logoImage} />
        ) : (
          ""
        )}
        {loadingLogo ? (
          <Button
            className={styles.loginButton}
            style={{ backgroundColor: themeColor, borderColor: themeColor }}
            onClick={() => {
              navigate("/login");
            }}
          >
            Login
          </Button>
        ) : (
          ""
        )}
      </header>
      <div className={styles.firstSec}>
        <FirstSection />
      </div>
      <div
        className={`${styles.mainContent} ${
          isScrolledPastFirstSec ? styles.scrollable : ""
        }`}
      >
        <div className={styles.leftContent}>
          <section className={styles.content} data-section="1">
            <SecondSection />
          </section>
          <section className={styles.content} data-section="2">
            <ThirdSection />
          </section>
          <section className={styles.content} data-section="3">
            <FourthSection />
          </section>
        </div>
        <div
          className={styles.rightContent}
          style={currentSection === 2 ? { top: "25%" } : {}}
        >
          {currentSection === 1 && (
            <Lottie
              options={lottieOptions(Security)}
              height={500}
              width={500}
            />
          )}
          {currentSection === 2 && (
            <div>
              <img
                src={laptopScreen}
                alt="laptopScreen"
                style={{ height: "100%", width: "500px" }}
              ></img>
              <Lottie
                options={lottieOptions(Success)}
                style={{
                  position: "absolute",
                  top: "16%",
                  width: "43%",
                  height: "58%",
                  left: "29%",
                }}
              />
            </div>
          )}
          {currentSection === 3 && (
            <Lottie
              options={lottieOptions(tracking)}
              height={500}
              width={500}
            />
          )}
        </div>
      </div>
      {/* <Partner
        backgroundColor={"#FFF7F3"}
        text={"Our Trusted Partners"}
        partnerData={partnerData}
      /> */}
      <GlobeSection />
      {/* <CarouselSection /> */}
      {/* <PictureSlider /> */}
      <Partner
        backgroundColor={"#FFE9FD"}
        text={"Send Money from any Bank in India"}
        partnerData={bankPartners}
      />
      {!loadingLogo ? (
        ""
      ) : offlineTransactionFlow === false ? (
        <LetGetStarted />
      ) : (
        ""
      )}
      <Footer />
    </div>
  );
}

export default Home;
